import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { useDeviationViewContext } from '../../../../Context';
import { getDeviationType, getPrimaryTier, isDeviationPixelArt, isFileLargerThanSize, scaleToSize, } from '../../../_helpers';
import { DeviationTypes } from '../../../../types/deviation';
import MediaService from '../../../../utils/DeviationMediaService';
import SubscribeButton from '../../../../Button/SubscribeButton';
import ImageContent from '../../Image/ImageContent';
import ContentShadow from '../ContentShadow';
import s from './SubPaywall.scss';
var SubPaywall = function (_a) {
    var _b, _c, _d;
    var width = _a.width, height = _a.height, deviation = _a.deviation, _e = _a.showImage, showImage = _e === void 0 ? false : _e, _f = _a.isStatusArtStage, isStatusArtStage = _f === void 0 ? false : _f, className = _a.className;
    var t = useTranslation().t;
    var isFullscreen = useDeviationViewContext().isFullscreen;
    var isPixel = isDeviationPixelArt(deviation);
    var isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
    var zoomedFile = MediaService.getLargestFullview(deviation);
    var isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
    var file = isHuge
        ? MediaService.getFullviewForSize(deviation, width, height)
        : zoomedFile;
    var tier = getPrimaryTier(deviation);
    if (!file || !tier) {
        return null;
    }
    var size = scaleToSize(file, { width: width, height: height });
    return (React.createElement("div", { className: classNames(s['root'], !showImage && s['no-image'], isStatusArtStage && s['status'], isFullscreen && s['fullscreen'], className), style: { width: width, height: height } },
        showImage && (React.createElement(ContentShadow, { content: file, containerSize: { width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height }, useSmallStage: true, className: s['overlay'] },
            React.createElement("div", null,
                React.createElement(ImageContent, { key: file.src, width: size === null || size === void 0 ? void 0 : size.width, height: size === null || size === void 0 ? void 0 : size.height, file: file, alt: (_b = deviation.title) !== null && _b !== void 0 ? _b : '', isPixel: isPixel, canZoom: false, onZoom: function () { } })),
            isFilm && React.createElement(VideoIcon, { className: s['video-icon'] }))),
        React.createElement("div", { className: s['centered'], style: size },
            React.createElement(TierBadge, { size: 40, isLocked: true, className: s['icon'] }),
            React.createElement("div", { className: s['title'] }, t('deviationview.subpaywall.title')),
            React.createElement("div", { className: s['main'] }, t('deviationview.subpaywall.body', {
                username: (_c = deviation === null || deviation === void 0 ? void 0 : deviation.author) === null || _c === void 0 ? void 0 : _c.username,
                price: (_d = tier.tier) === null || _d === void 0 ? void 0 : _d.dollarPrice,
            })),
            React.createElement(SubscribeButton, { tier: tier, 
                // TODO: send to ponies
                onClick: function () { return alert("subscribing to " + tier.title); } }))));
};
SubPaywall.displayName = 'SubPaywall';
export default SubPaywall;
//# sourceMappingURL=SubPaywall.js.map